import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import SearchModal from './components/SearchModal';
import KeyboardHint from './components/KeyboardHint';
import { useModalTrigger } from './hooks/useModalTrigger';
import { loadIndex } from './lib/index-loader';
const App = () => {
    const { isOpen, open, close } = useModalTrigger();
    const [state, setState] = useState({
        indexLoaded: false,
        products: [],
        synonyms: {},
        error: null,
    });
    // Preload index on mount
    useEffect(() => {
        const preload = async () => {
            try {
                const config = window.enoSearchConfig;
                const { products, synonyms } = await loadIndex(config);
                setState({
                    indexLoaded: true,
                    products,
                    synonyms,
                    error: null,
                });
            }
            catch (err) {
                setState({
                    indexLoaded: false,
                    products: [],
                    synonyms: {},
                    error: err instanceof Error ? err.message : 'Failed to load search index',
                });
            }
        };
        preload();
    }, []);
    const showFloating = !!window.enoSearchConfig?.showFloatingTrigger;
    return (_jsxs("div", { className: "eno-search-app", children: [showFloating && _jsx(KeyboardHint, { onClick: open }), _jsx(SearchModal, { isOpen: isOpen, onClose: close, products: state.products, synonyms: state.synonyms, indexLoaded: state.indexLoaded, error: state.error })] }));
};
export default App;
